export default __webpack_public_path__ + "static/AeonikBold-cce10ffca45b9fb0d664c1f4812942be.woff";